/** Global Imports */
import React from 'react';

/** Component Imports */
import { styles } from './styles';
import ModelDesignerLogo from 'images/model-designer.svg';
import CalculationWorkflowLogo from 'images/calculation-workflow-logo.svg';
import LabDataLogo from 'images/lab-data-logo.svg';
import CalcNotebookLogog from 'images/calc-notebook-icon.svg';
import FrostImage from 'images/Icon_FrostModule.png';
import CoilPC from 'images/Icon_CoilPC.png';
import QuickLinks from 'components/common/quick-links';

export default function ProgramWorkflowLinks({ programId }) {
  const classes = styles();
  const quickLinks = [
    {
      name: 'Model Designer',
      thumbnail: ModelDesignerLogo,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_DESIGNER_ORIGIN || window.location.origin
        }/designer/#/program/${programId}`, //For micro-front end
      },
      navigationState: null,
    },
    {
      name: 'Lab Data',
      thumbnail: LabDataLogo,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_LABDATA_ORIGIN || window.location.origin
        }/labdata/#/program/${programId}`,
      },
      navigationState: null,
    },
    {
      name: 'Computation Notebook',
      thumbnail: CalcNotebookLogog,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_COMPUTATION_NOTEBOOK_ORIGIN ||
          window.location.origin
        }/computation-notebook/index.html`,
      },
      shouldHide: {
        qa: true,
        prod: true,
      },
      navigationState: null,
    },
    {
      name: 'Calculation Workflow',
      thumbnail: CalculationWorkflowLogo,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_CALCULATION_WORKFLOW_ORIGIN ||
          window.location.origin
        }/calculationworkflow/#/program/${programId}`,
      },
      navigationState: null,
    },
    {
      name: 'Frost Analysis',
      thumbnail: FrostImage,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_CALCULATION_WORKFLOW_ORIGIN ||
          window.location.origin
        }/frost-analysis/#/program/${programId}`,
      },
      navigationState: null,
      shouldHide: {
        qa: true,
        prod: true,
      },
    },
    {
      name: 'Coil PC',
      thumbnail: CoilPC,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_CALCULATION_WORKFLOW_ORIGIN ||
          window.location.origin
        }/coilpc/program/${programId}`,
      },
      shouldHide: {
        qa: true,
        prod: true,
      },
    },
    {
      name: 'TestingFUN',
      thumbnail: CalculationWorkflowLogo,
      navigationRoute: {
        external: {
          newTab: false,
        },
        path: `${
          process.env.REACT_APP_MFE_CALCULATION_WORKFLOW_ORIGIN ||
          window.location.origin
        }/testingfun/#/program/${programId}`,
      },
      navigationState: null,
    },
  ];

  const currentEnvironment = process.env.REACT_APP_ENV || 'local';

  // Filter the links for the current environment
  const visibleLinks = quickLinks.filter(
    (link) => !(link.shouldHide && link.shouldHide[currentEnvironment]),
  );

  return (
    <div className={classes.root}>
      <QuickLinks links={visibleLinks} />
    </div>
  );
}
